import React from 'react'

import { Card, Typography, Link, Grid } from "@mui/material"
import { customColors } from './RebateWidget';

interface RebateResultNotFoundProps {
    zip : string
    colors: customColors
}

const RebateResultNotFound : React.FC<RebateResultNotFoundProps> = ({colors, zip}) => {
    return(
    <>
        <Card  sx={{
                marginTop: "10px",
                paddingLeft: "0px",
                paddingRight: "0px",
                marginBottom: "2px",
                fontWeight: "bold",
                backgroundColor: "white",
                border: "2px solid " + colors.forestGreenBg,
                borderRadius: '2px'            
            }}>
                <Grid container spacing={0} marginTop={0} marginBottom={2} columnSpacing={0} columns={12}>
                    <Grid xs={12} md={12} bgcolor={colors.cloudGrayBg} border={2} borderColor={colors.midGrayBg}>
                        <Typography color={colors.oceanBlueBg} fontWeight={'bold'} fontSize={'1.2em'} sx={{
                            padding: "5px",
                            variant: "h3",
                            display: "flex",
                        }}>
                            No rebates found for {zip}</Typography>
                    </Grid>
                    <Grid xs={12} md={12} >
                        <Typography variant="body1" sx={{
                            padding: "5px",
                            paddingLeft: "15px",
                            paddingRight: "15px",                               
                            fontSize: '16px', 
                        }}>
                            Visit <Link href='https://www.energystar.gov/rebatefinder'>ENERGY STAR Rebate Finder</Link> to search for rebates and special offers on other products in your area.
                        </Typography>
                    </Grid>
                </Grid>
        </Card>
    </>
    )
}

export default RebateResultNotFound